export { PriceSmall, Title, PriceCrossed } from './ProductComponents.styled';
